import { createSlice } from "@reduxjs/toolkit";

const now = new Date();
var startdate;
var enddate;
startdate = new Date(now);
startdate.setHours(0, 0, 0, 0); // Start of today
enddate = new Date(now);
enddate.setHours(23, 59, 59, 999); // End of today
var startdate_dashboard = startdate;
var enddate_dashboard = enddate;

export const mainpagedata = createSlice({
  name: "mainpagedata",

  initialState: {
    overviewbarstate: true,
    treepathselected: ["Manufacturing Plant"],
    alarmtreepathselected: ["Alert Data"],
    selectedtabpath: [],
    selectedpath: [],
    selecteddate: "This Year",
    selecteddates: {
      startdates: "Sun Jan 01 2023 00:00:00 GMT+0530 (India Standard Time)",
      enddates: "Sun Dec 31 2023 00:00:00 GMT+0530 (India Standard Time)",
      repstartdates: "Sun Jan 01 2023 00:00:00 GMT+0530 (India Standard Time)",
      rependdates: "Sun Dec 31 2023 00:00:00 GMT+0530 (India Standard Time)",
    },
    selecteddates_dashboard: {
      startdates: startdate_dashboard,
      enddates: enddate_dashboard,
    },
    dashboardjsontags: [],
    tagcollectionvalues: {},
    tagcollectionvaluesnewjson: {},
    tagaliascollectionvaluesnewjson:{},
    updateddashboarddata: {},
    selectedprojectname: "",
    filter: "All",
    selectedtreedashboard: {},
    dynamicObject: {},
    tagcollection: {},
    livedata: [],
    livedata1: [],
    liveoverviewdata: {},
    historicaldata: [],
    tagdetailsobject: {},
    devicedetailsobject: {},
    selectedStores: [],
    generalConfiguration: {
      energyBaseline : 0,
      energyTarget : 0,
      energyMaxLimit : 0,
      energyPerUnitCost : 0,
      costBaseline : 0,
      costTarget : 0,
      costUnit : '₹',
      energyUnit : 'Wh',
      energyUnitType : 'Wh',
      decimalPoints: 2,
      alertSoundSettings:{'HighestPriority':false,'HighPriority':false,'MediumPriority':false,'LowPriority':false}
    },
    dashboardMapState:{},
  },

  reducers: {
    updateoverviewbarstate: (state, overviewstate) => {
      state.overviewbarstate = overviewstate.payload;
    },
    updatetreepathselected: (state, treepath) => {
      state.treepathselected = treepath.payload;
    },
    updatealarmtreepathselected: (state, alarmtreepath) => {
      state.alarmtreepathselected = alarmtreepath.payload;
    },
    updatetabpath: (state, tabpath) => {
      state.selectedtabpath = tabpath.payload;
    },
    updateselectedpath: (state, selectpath) => {
      state.selectedpath = selectpath.payload;
    },
    updatedateselection: (state, dateselected) => {
      console.log("dateselected.payload ", dateselected.payload);
      state.selecteddate = dateselected.payload;
    },
    updatedateselection_sdate_edate: (state, dateselected) => {
      // console.log("dateselected.payload ",dateselected.payload)
      const {
        selectedstartdate,
        selectedenddate,
        selectedrepstartdate,
        selectedrependdate,
      } = dateselected.payload;
      state.selecteddates.startdates = new Date(selectedstartdate);
      state.selecteddates.enddates = new Date(selectedenddate);
      state.selecteddates.repstartdates = new Date(selectedrepstartdate);
      state.selecteddates.rependdates = new Date(selectedrependdate);
    },
  updateselecteddates_dashboard: (state, dateselected) => {
      // console.log("dateselected.payload ",dateselected.payload)
      const { selectedstartdate_dashboard, selectedenddate_dashboard} = dateselected.payload;
      state.selecteddates_dashboard.startdates= new Date(selectedstartdate_dashboard);
      state.selecteddates_dashboard.enddates= new Date(selectedenddate_dashboard);
  },
    updatedashboarddata: (state, newdata) => {
      state.updateddashboarddata = newdata.payload;
    },
    updatetagcollection: (state, tagcollectiondata) => {
      state.tagcollection = tagcollectiondata.payload;
    },
    updateselectedprojectname: (state, project) => {
      state.selectedprojectname = project.payload;
    },
    updatefilter: (state, selectfilter) => {
      state.filter = selectfilter.payload;
    },
    updateselectedtreedashboard: (state, selectedtree) => {
      state.selectedtreedashboard = selectedtree.payload;
    },
    updateDynamicObject(state, action) {
      state.dynamicObject = action.payload;
    },
    updateKeyValue(state, action) {
      const { key, value } = action.payload;
      state.dynamicObject[key] = value;
    },
    updatetagcollectionvalue(state, tagcollect) {
      state.tagcollectionvalues = tagcollect.payload;
    },
    updatetagcollectionvaluenewjson(state, tagcollect) {
      state.tagcollectionvaluesnewjson = tagcollect.payload;
    },
    updatetagaliascollectionvaluenewjson(state, tagcollect) {
      state.tagaliascollectionvaluesnewjson = tagcollect.payload;
    },
    updatehistoricalvalue(state, tagcollect) {
      state.historicaldata = tagcollect.payload;
    },
    updatelivedata: (state, data) => {
      state.livedata = data.payload;
    },
     updatelivedata1: (state, data) => {
      state.livedata1 = data.payload;
    },
    updateliveoverviewdata: (state, data) => {
      state.liveoverviewdata = data.payload;
    },
    updatedashboardjsontags: (state, data) => {
      state.dashboardjsontags = data.payload;
    },
    updatetagdetailsobject: (state, data) => {
      state.tagdetailsobject = data.payload;
    },
    updatedevicedetailsobject: (state, data) => {
      state.devicedetailsobject = data.payload;
    },
    setSelectedStores: (state, action) => {
      state.selectedStores = action.payload;
    },
    updategeneralConfiguration: (state, data) => {
      state.generalConfiguration = data.payload;
    },
    updategeneralconfig: (state, data) => {
      state.generalconfig = data.payload;
    },
    updatedashboardMap: (state, selectedtree) => {
      state.dashboardMapState = selectedtree.payload;
    },
  },
});

export const {
  updateoverviewbarstate,
  updatetreepathselected,
  updatealarmtreepathselected,
  updatetabpath,
  updateselectedpath,
  updatedateselection,
  updatedashboarddata,
  updateselectedprojectname,
  updatefilter,
  updatetreeintialpath,
  updateselectedtreedashboard,
  updatedateselection_sdate_edate,
  updatetagcollection,
  updatetagcollectionvaluenewjson,
  updatetagaliascollectionvaluenewjson,
  updateDynamicObject,
  updateKeyValue,
  updatetagcollectionvalue,
  updatelivedata,
  updatelivedata1,
  updateliveoverviewdata,
  updatehistoricalvalue,
  updatedashboardjsontags,
  updateselecteddates_dashboard,
  updatetagdetailsobject,
  updatedevicedetailsobject,
  setSelectedStores,
  updategeneralConfiguration,
  updategeneralconfig,
  updatedashboardMap
} = mainpagedata.actions;
export default mainpagedata.reducer;
